import { observable, action, computed } from "mobx";
import { SBMsgBus } from "sb-msg-bus";
import { GeoTopics } from "sb-msg-bus/lib/MessageBusTopics/GeoComply";
import { HeaderRegulationMessageType } from "../types";

/*
    Tests describing the structure of the ouput data should be written first.
    It would be better to split the tests into few suits:
    - base tests related to class and instance structure
    - business logic
    - edge cases
*/

export class HeaderRegulationRibbonMessageBlockData {
    public eventsManager: any;
    public messageBus: SBMsgBus;
    @observable shouldHide: boolean;
    @observable message: HeaderRegulationMessageType;
    @observable isExpanded: boolean;
    @observable hasButton: boolean;

    constructor(provider: any) {
        this.eventsManager = provider.eventsManager;
        this.messageBus = provider.messageBusProvider;
        this.shouldHide = true;
        this.message = {key:"",messageText:""};
        this.isExpanded = false;
        this.hasButton = false;

        this.eventsManager.addEventListener("showRegulationMessageonUserLogin", this, this.showBlock, true);
        this.eventsManager.addEventListener("hideRegulationMessageonUserLogout", this, this.hideBlock, true);
        this.messageBus && this.messageBus.subscribe(GeoTopics.SB_ShowRegulationMessageonUserLogin, this.showBlock.bind(this))
    }

    @action showBlock(message:string|HeaderRegulationMessageType) {
        this.message = this.getValidatedMessage(message);
        this.shouldHide = false;
    }

    @action hideBlock(message?:HeaderRegulationMessageType) {
        if (message)
        {
            if (message.key === this.message.key)
            {
                this.shouldHide = true;
                this.message = {messageText:"",key:""}
            }
        }
        else
        {
            this.shouldHide = true;
            this.message = {messageText:"",key:""}
        }
    }

    getValidatedMessage(message:string|HeaderRegulationMessageType):HeaderRegulationMessageType {
        let validatedMessage = {} as HeaderRegulationMessageType;
        if (typeof message === "string") {
            validatedMessage.key = "";
            validatedMessage.messageText = message;
        } else if (message) {
            validatedMessage.key = message.key || "";
            validatedMessage.messageText = message.messageText || "";
        } else if (message === undefined)
        {
            validatedMessage.key = "";
            validatedMessage.messageText = "";
        }
        return validatedMessage;
    }

    @action.bound changeExpanded(e) {
        this.isExpanded = !this.isExpanded;
    }

    @action.bound winResizeHandler(containerElWidth: number, messageElWidth: number) {
        this.hasButton = containerElWidth < messageElWidth;
    }

    @computed get chooseModifier() {
        return this.isExpanded ? "read-less" : "read-more";
    }

    @computed get chooseBtnText() {
        return this.isExpanded ? "ReadLess" : "ReadMore";
    }
}